module.exports = [
  {
    title: 'Masaüstünde Linux Yılı',
    slug: 'masaustunde-linux-yili',
    date: '2026-08-28',
    summary: 'DHH\'in kurduğu Omacom Vakfı, Omarchy projesi ve vadinin liderlerinden toplanan 10 milyon dolarlık açık kaynak fonuyla Linux masaüstü devrimi.',
    file: '/blog/masaustunde-linux-yili.md',
    tags: ['Linux', 'Open Source', 'Omarchy', 'DHH', 'Ruby on Rails']
  },
  {
    title: 'Yazılımı seviyorum...',
    slug: 'yazilimi-seviyorum',
    date: '2026-07-14',
    summary: 'Statik ve dinamik tipleme tartışmasına Python ve Rust üzerinden kişisel bir bakış.',
    file: '/blog/yazilimi-seviyorum.md',
    tags: ['Software', 'Rust', 'Python', 'Static Typing']
  }
];
